import React from "react";

/**
 * @component SearchLargeIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 *
 * @example
 * return (
 *   <SearchLargeIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const SearchLargeIcon = React.forwardRef(
  (props: React.SVGProps<SVGSVGElement>, svgRef?: React.Ref<SVGSVGElement>) => (
    <svg
      width={32}
      height={32}
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="SearchLargeIcon"
      fill="var(--color-theme-600)"
      focusable={false}
      ref={svgRef}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14 4c5.523 0 10 4.477 10 10 0 2.31-.783 4.436-2.098 6.129.088.04.17.09.248.15l.126.111 5.334 5.334a1.333 1.333 0 01-1.76 1.996l-.126-.11-5.334-5.334a1.332 1.332 0 01-.263-.373A9.953 9.953 0 0114 24C8.477 24 4 19.523 4 14S8.477 4 14 4zm0 2.667a7.333 7.333 0 100 14.666 7.333 7.333 0 000-14.666z"
      />
    </svg>
  )
);
SearchLargeIcon.displayName = "SearchLargeIcon";
export default SearchLargeIcon;
